// src/LoadingIcon.tsx
import { jsx } from "react/jsx-runtime";
var LoadingIcon = ({ ...props }) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        d: "M12 2C10.0222 2 8.08879 2.58649 6.4443 3.6853C4.79981 4.78412 3.51809 6.3459 2.76121 8.17317C2.00433 10.0004 1.8063 12.0111 2.19215 13.9509C2.578 15.8907 3.53041 17.6725 4.92894 19.0711C6.32746 20.4696 8.10929 21.422 10.0491 21.8079C11.9889 22.1937 13.9996 21.9957 15.8268 21.2388C17.6541 20.4819 19.2159 19.2002 20.3147 17.5557C21.4135 15.9112 22 13.9778 22 12C22 11.4477 22.4477 11 23 11C23.5523 11 24 11.4477 24 12C24 14.3734 23.2962 16.6935 21.9776 18.6668C20.6591 20.6402 18.7849 22.1783 16.5922 23.0866C14.3995 23.9948 11.9867 24.2324 9.65892 23.7694C7.33114 23.3064 5.19295 22.1635 3.51472 20.4853C1.83649 18.8071 0.693605 16.6689 0.230582 14.3411C-0.232441 12.0133 0.00519403 9.60051 0.913446 7.4078C1.8217 5.21509 3.35977 3.34094 5.33316 2.02236C7.30655 0.703788 9.62662 0 12 0C12.5523 0 13 0.447715 13 1C13 1.55228 12.5523 2 12 2Z",
        fill: "currentColor",
        children: /* @__PURE__ */ jsx(
          "animateTransform",
          {
            attributeName: "transform",
            attributeType: "XML",
            type: "rotate",
            from: "0 12 12",
            to: "360 12 12",
            dur: "1s",
            repeatCount: "indefinite"
          }
        )
      }
    )
  }
);
var LoadingIcon_default = LoadingIcon;

export {
  LoadingIcon_default
};
